import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complaintService } from '../../services/complaintService';

export const useGetParticipatingFundraisingList = () => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour
    queryKey: [QUERY_KEYS.complaint.participating_fundraising],
    queryFn: () =>
      complaintService.participatingFundraising().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
